var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselIconRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "30px",
    viewBox: "0 0 16 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Right_Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.39148875,27.0914887 L12.7976437,14.6853337 L0.39148875,2.27917875 C-0.13049625,1.75852875 -0.13049625,0.91213875 0.39148875,0.39148875 C0.91213875,-0.13049625 1.75852875,-0.13049625 2.27917875,0.39148875 L15.6291787,13.7414887 C16.1511637,14.2621388 16.1511637,15.1085288 15.6291787,15.6291787 L2.27917875,28.9791787 C1.75852875,29.5011637 0.91213875,29.5011637 0.39148875,28.9791787 C-0.13049625,28.4585287 -0.13049625,27.6121387 0.39148875,27.0914887 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-KnowledgeBase",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Right_Icon",
    fill: "#0067DF",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselIconRight);
export default __webpack_public_path__ + "static/media/Carousel_Icon_Right.035bbad578792b9e8ca00105be55e930.svg";
export { ForwardRef as ReactComponent };